module.exports = __webpack_public_path__ + "static/media/jirou-kyouka-win.fe9340b9.png";